import React from "react";
import "../../styles/m3d-vantagens.css";

export default function ComoResgatar() {
  return (
    <section className="como-resgatar">
      <div className="container-limited">
        <h2>Como resgatar</h2>

        <p className="resgatar-text">
          Basta solicitar o resgate pelo WhatsApp e informar que deseja utilizar seus pontos.
        </p>

        <div className="whatsapp-card">
          <div className="phone-box">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="#25D366" xmlns="http://www.w3.org/2000/svg" aria-hidden>
              <path d="M20.487 3.513A11.904 11.904 0 0012 0C5.373 0 .002 5.372 0 12c0 2.12.55 4.145 1.597 5.937L0 24l6.27-1.594A11.94 11.94 0 0012 24c6.627 0 12-5.373 12-12 0-3.2-1.246-6.206-3.513-8.487z"/>
            </svg>
            <h3 className="whatsapp-number">051 99392-6662</h3>
          </div>
          <div className="whatsapp-action">
            <a href="https://api.whatsapp.com/send/?phone=5551982085713" target="_blank" rel="noreferrer">
              <button className="btn-primary">Falar com atendimento</button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
